<template>
  <div>
    <a-col>
      <a-row :span="12">
        <a-table
          :columns="columns"
          :dataSource="document.HISTORY"
          :pagination="{ pageSize: 15 }"
          bordered
        >
        </a-table>
      </a-row>
      <a-row :span="12" style="margin-bottom: 15px;"></a-row>
    </a-col>
  </div>
</template>
<script>
export default {
  props: ["document", "info"],
  data() {
    let changeLocals = {
      document_type: this.$t("Document type"),
      date_send: this.$t("Date of receiving"),
      date_recept: this.$t("Date of receiving"),
      title: this.$t("Document name"),
      my_company: this.$t("main_company_n_hub"),
      kontragent: this.$t("Contractor"),
      comments: this.$t("Comment"),
      mpk: this.$t("MPK"),
      SPECJALIZACJA: this.$t("Specialization"),
      num_doc: this.$t("Document number"),
      tags: this.$t("Keywords"),
      key_words: this.$t("Keywords"),
      Teczka: this.$t("Tag"),
      arch_doc_type: this.$t("Original"),
      arch_doc_number: this.$t("Folder number")
    };
    const columns = [
      {
        title: this.$t("Date of change"),
        dataIndex: "date_change"
      },
      {
        title: this.$t("User"),
        dataIndex: "creator",
        customRender: text => {
          let user = this.info.data_user.find(x => x.ID == text);
          return user.NAME + " " + user.LAST_NAME;
        }
      },
      {
        title: this.$t("Change type"),
        dataIndex: "type_change",
        customRender: text => {
          return changeLocals[text];
        }
      },
      {
        title: this.$t("Old value"),
        dataIndex: "old",
        customRender: (text, record) => {
          if (record.type_change in this.info) {
            let comp = this.info[record.type_change].find(x => x.ID == text);
            return comp != undefined ? comp.TITLE : "";
          } else if (record.type_change == "kontragent") {
            let comp = this.info.company.find(x => x.ID == text);
            return comp != undefined ? comp.TITLE : "";
          } else if (record.type_change == "key_words" && text != "null") {
            return JSON.parse(text).reduce(
              (accumulator, currentValue) => accumulator + ", " + currentValue
            );
          } else {
            return text == "null" ? "" : text;
          }
        }
      },
      {
        title: this.$t("New value"),
        dataIndex: "new",
        customRender: (text, record) => {
          if (record.type_change in this.info) {
            let comp = this.info[record.type_change].find(x => x.ID == text);
            return comp.TITLE;
          } else if (record.type_change == "kontragent") {
            let comp = this.info.company.find(x => x.ID == text);
            return comp != undefined ? comp.TITLE : "";
          } else if (record.type_change == "key_words" && text != "null") {
            return JSON.parse(text).reduce(
              (accumulator, currentValue) => accumulator + ", " + currentValue
            );
          } else {
            return text == "null" ? "" : text;
          }
        }
      }
    ];
    return {
      count: 10,
      document_record: 0,
      columns
    };
  }
};
</script>

<style scoped>
</style>
